import { createBrowserRouter, createRoutesFromElements, Route, Outlet, type RouteObject } from 'react-router-dom';

import { HOMEPAGE } from '@/constants/routes.constants';
import {
	generateConferenciasRoutes,
	generateHomeRoutes,
	generateInnerRoutes,
	academiaRoutes,
	homeRoute,
	innerRoutes,
} from './appRoutes';
import { conferenciasGateLoader } from './conferenciasGate';

// Export const routes: RouteObject[] = createRoutesFromElements(
// 	<>
// 		{generateHomeRoutes(homeRoute)}
// 		{generateInnerRoutes(innerRoutes)}
// 		{generateConferenciasRoutes(academiaRoutes)}
// 	</>,
// );

export const routes: RouteObject[] = createRoutesFromElements(
	<Route loader={conferenciasGateLoader} element={<Outlet />}>
		{generateConferenciasRoutes(academiaRoutes)}
		{generateHomeRoutes(homeRoute)}
		{generateInnerRoutes(innerRoutes)}
	</Route>,
);

export const router = createBrowserRouter(routes, { basename: HOMEPAGE });
